// This file has been generated from LT.Web.ViewModels.LocationEntryTSVM
import GeoBoundingBoxTSVM from "@Types/search/GeoBoundingBoxTSVM";

export default class LocationEntryTSVM {

    id: number;
    label: string;
    desc: string;
    aId: number;
    iconUrl: string;
    parentOrderWeight?: number;
    subEntries: Array<LocationEntryTSVM>;
    parentId?: number;
    geoBox: GeoBoundingBoxTSVM;


	constructor(id: number, label: string, desc: string, aId: number, iconUrl: string, geoBox: GeoBoundingBoxTSVM){
	
        this.id = id;
        this.label = label;
        this.desc = desc;
        this.aId = aId;
        this.iconUrl = iconUrl;
        this.subEntries = new Array<LocationEntryTSVM>();
        this.geoBox = geoBox;
	}
}